/* =========================================================
   PadelVault Theme — theme.js
   Vanilla JS. No dependencies. Progressive enhancement.
   ========================================================= */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------------------------------------------------
     Utilities
     --------------------------------------------------- */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    format = format || '£{{amount}}';
    return format.replace('{{amount}}', value);
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------
     Fade-up on scroll (Intersection Observer)
     --------------------------------------------------- */
  function initFadeUp() {
    var items = qsa('.fade-up');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------------------------------------------
     Mobile navigation
     --------------------------------------------------- */
  function initMobileNav() {
    var nav = qs('[data-mobile-nav]');
    var openBtn = qs('[data-mobile-nav-open]');
    var closeBtn = qs('[data-mobile-nav-close]');
    var backdrop = nav ? qs('.mobile-nav__backdrop', nav) : null;
    if (!nav || !openBtn) return;

    function open() {
      nav.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      openBtn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      nav.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
      openBtn.setAttribute('aria-expanded', 'false');
    }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------------------------------------------------
     FAQ accordion
     --------------------------------------------------- */
  function initFaq() {
    qsa('.faq-item').forEach(function (item) {
      var btn = qs('.faq-item__question', item);
      var panel = qs('.faq-item__panel', item);
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        qsa('.faq-item', item.parentElement).forEach(function (other) {
          other.setAttribute('data-open', 'false');
          qs('.faq-item__panel', other).style.maxHeight = null;
          qs('.faq-item__question', other).setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.setAttribute('data-open', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------------------------------------------------
     Product gallery (swipe + dots + thumbs)
     --------------------------------------------------- */
  function initGalleries() {
    qsa('[data-product-gallery]').forEach(function (gallery) {
      var track = qs('.product-gallery__track', gallery);
      var dots = qsa('.product-gallery__dot', gallery);
      var thumbs = qsa('.product-gallery__thumb', gallery);
      var slides = qsa('.product-gallery__slide', gallery);
      if (!track || !slides.length) return;

      function setActive(index) {
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      }

      track.addEventListener('scroll', function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        setActive(index);
      }, { passive: true });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        });
      });

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------------------------------------------------
     Quantity steppers
     --------------------------------------------------- */
  function initQuantitySteppers() {
    qsa('[data-quantity-wrapper]').forEach(function (wrapper) {
      var input = qs('.qty-input', wrapper);
      var minus = qs('[data-qty-minus]', wrapper);
      var plus = qs('[data-qty-plus]', wrapper);
      if (!input) return;
      minus && minus.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      plus && plus.addEventListener('click', function () {
        var val = (parseInt(input.value, 10) || 1) + 1;
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------------------------------------------------
     Bundle selector (variant radio cards)
     --------------------------------------------------- */
  function initBundleSelectors() {
    qsa('[data-bundle-cards]').forEach(function (wrapper) {
      var cards = qsa('.bundle-card', wrapper);
      var scope = wrapper.closest('[data-product-scope]') || wrapper.closest('form');
      var priceEl = scope ? qs('[data-product-price]', scope) : null;
      var comparePriceEl = scope ? qs('[data-product-compare-price]', scope) : null;

      function select(card) {
        cards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        var radio = qs('input[type="radio"]', card);
        if (radio) radio.checked = true;

        if (priceEl && card.dataset.price) {
          priceEl.textContent = formatMoney(parseInt(card.dataset.price, 10));
        }
        if (comparePriceEl) {
          if (card.dataset.comparePrice && parseInt(card.dataset.comparePrice, 10) > parseInt(card.dataset.price, 10)) {
            comparePriceEl.textContent = formatMoney(parseInt(card.dataset.comparePrice, 10));
            comparePriceEl.hidden = false;
          } else {
            comparePriceEl.hidden = true;
          }
        }
        syncStickyAtc();
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () { select(card); });
      });
    });
  }

  /* ---------------------------------------------------
     Sticky Add To Cart bar
     --------------------------------------------------- */
  var stickyAtcSyncFns = [];
  function syncStickyAtc() {
    stickyAtcSyncFns.forEach(function (fn) { fn(); });
  }

  function initStickyAtc() {
    var sticky = qs('[data-sticky-atc]');
    var mainForm = qs('[data-product-form]');
    if (!sticky || !mainForm) return;

    var trigger = qs('[data-product-form-submit]', mainForm);
    var stickyPrice = qs('[data-sticky-price]', sticky);
    var stickySubmit = qs('[data-sticky-submit]', sticky);
    var priceScope = mainForm.closest('[data-product-scope]') || mainForm.parentElement || mainForm;
    var priceEl = qs('[data-product-price]', priceScope);

    stickyAtcSyncFns.push(function () {
      if (stickyPrice && priceEl) stickyPrice.textContent = priceEl.textContent;
    });

    if (!('IntersectionObserver' in window) || !trigger) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(trigger);

    if (stickySubmit) {
      stickySubmit.addEventListener('click', function () {
        mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  /* ---------------------------------------------------
     Cart drawer + AJAX cart
     --------------------------------------------------- */
  var CartDrawer = (function () {
    var drawer = qs('[data-cart-drawer]');
    if (!drawer) return null;

    var backdrop = qs('.cart-drawer__backdrop', drawer);
    var closeBtn = qs('[data-cart-drawer-close]', drawer);
    var body = qs('[data-cart-drawer-body]', drawer);
    var footer = qs('[data-cart-drawer-footer]', drawer);
    var countBubbles = qsa('[data-cart-count]');

    function open() {
      drawer.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
    }

    closeBtn && closeBtn.addEventListener('click', close);
    backdrop && backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    function updateCountBubbles(count) {
      countBubbles.forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    function render(cart) {
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = '<div class="cart-drawer__empty"><p>' + (window.themeStrings && window.themeStrings.cartEmpty || 'Your cart is empty') + '</p></div>';
        if (footer) footer.hidden = true;
        updateCountBubbles(0);
        return;
      }
      if (footer) footer.hidden = false;

      var html = cart.items.map(function (item) {
        return (
          '<div class="cart-line" data-line-key="' + item.key + '">' +
            '<div class="cart-line__image"><img src="' + (item.image || '') + '" alt="' + item.product_title + '" loading="lazy" width="76" height="76"></div>' +
            '<div class="cart-line__info">' +
              '<div class="cart-line__title">' + item.product_title + '</div>' +
              (item.variant_title ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '') +
              '<div class="cart-line__row">' +
                '<div class="cart-line__qty">' +
                  '<button type="button" data-cart-qty-minus aria-label="Decrease quantity">&minus;</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-cart-qty-plus aria-label="Increase quantity">&plus;</button>' +
                '</div>' +
                '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
              '</div>' +
              '<button type="button" class="cart-line__remove" data-cart-remove>' + (window.themeStrings && window.themeStrings.remove || 'Remove') + '</button>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      body.innerHTML = html;

      var subtotalEl = qs('[data-cart-subtotal]', footer);
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);

      updateCountBubbles(cart.item_count);
      bindLineEvents();
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); return cart; });
    }

    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function (cart) { render(cart); return cart; });
    }

    function bindLineEvents() {
      qsa('[data-cart-qty-minus]', body).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('[data-line-key]');
          var qtyEl = qs('.cart-line__qty span', line);
          var qty = Math.max(0, parseInt(qtyEl.textContent, 10) - 1);
          changeLine(line.dataset.lineKey, qty);
        });
      });
      qsa('[data-cart-qty-plus]', body).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('[data-line-key]');
          var qtyEl = qs('.cart-line__qty span', line);
          var qty = parseInt(qtyEl.textContent, 10) + 1;
          changeLine(line.dataset.lineKey, qty);
        });
      });
      qsa('[data-cart-remove]', body).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('[data-line-key]');
          changeLine(line.dataset.lineKey, 0);
        });
      });
    }

    fetchCart();

    return { open: open, close: close, fetchCart: fetchCart, updateCountBubbles: updateCountBubbles };
  })();

  function initCartTriggers() {
    qsa('[data-cart-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (CartDrawer) { e.preventDefault(); CartDrawer.open(); }
      });
    });
  }

  /* ---------------------------------------------------
     Product add-to-cart forms (AJAX)
     --------------------------------------------------- */
  function initProductForms() {
    qsa('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = qs('[data-product-form-submit]', form);
        var formData = new FormData(form);
        formData.append('sections_url', window.location.pathname);

        if (submitBtn) submitBtn.classList.add('btn-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function () {
            if (CartDrawer) {
              CartDrawer.fetchCart().then(function () { CartDrawer.open(); });
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (err) {
            console.error('Add to cart error', err);
            alert(err && err.description ? err.description : 'This item could not be added to your cart.');
          })
          .finally(function () {
            if (submitBtn) submitBtn.classList.remove('btn-loading');
          });
      });
    });
  }

  /* ---------------------------------------------------
     Bundle "add both to cart" (two products, one click)
     --------------------------------------------------- */
  function initBundleAddButtons() {
    qsa('[data-bundle-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantA = btn.dataset.variantA;
        var variantB = btn.dataset.variantB;
        if (!variantA || !variantB) return;

        btn.classList.add('btn-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: variantA, quantity: 1 },
              { id: variantB, quantity: 1 }
            ]
          })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function () {
            if (CartDrawer) {
              CartDrawer.fetchCart().then(function () { CartDrawer.open(); });
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (err) {
            console.error('Add both to cart error', err);
            alert(err && err.description ? err.description : 'These items could not be added to your cart.');
          })
          .finally(function () {
            btn.classList.remove('btn-loading');
          });
      });
    });
  }

  /* ---------------------------------------------------
     Newsletter form (demo submit, replace with real endpoint)
     --------------------------------------------------- */
  function initNewsletterForms() {
    qsa('[data-newsletter-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = qs('button[type="submit"]', form);
        if (btn) btn.classList.add('btn-loading');
      });
    });
  }

  /* ---------------------------------------------------
     Init
     --------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initFadeUp();
    initMobileNav();
    initFaq();
    initGalleries();
    initQuantitySteppers();
    initBundleSelectors();
    initStickyAtc();
    initCartTriggers();
    initProductForms();
    initBundleAddButtons();
    initNewsletterForms();
  });
})();
